import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ELogoutActionTypes, TLogoutSucceed } from './types';

export const logoutSuccess: () => TLogoutSucceed = actionGenerator<ELogoutActionTypes.Succeed>(
  ELogoutActionTypes.Succeed,
);
